<template>
	<div>
		<CContainer class="d-flex content-center bg-white">
			<div>
				<CRow>
					<CCol sm="5" class="">
						<img
							class="img-fluid"
							:src="imgInfofriend1"
							alt="infoFriend1"
						/>
					</CCol>
					<br />
					<CCol sm="7" class="" style="margin-top: 70px;">
						<h3 class="borderInfoFriend">
							¡Hola {{ userInfo.name }}!
						</h3>
						<br />
					</CCol>
				</CRow>
			</div>
		</CContainer>
	</div>
</template>
<script>
	export default {
		/** Componente que sirve para el dashboard(home) del sistema cuando el
		 * usuario inicia sesión en el sistema */
		name: 'Dashboard',
		title: 'Mail Update | Infoguia',
		beforeCreate: function() {},
		created() {
			this.userInfo = JSON.parse(sessionStorage.getItem('userData'));
			this.imgInfofriend1 = process.env.VUE_APP_WELCOME_INFOFRIEND1;
		},
		data() {
			return {
				imgInfofriend1: '',
				userInfo: {},
			};
		},
		methods: {},
	};
</script>
